import { render, staticRenderFns } from "./block-rental-allocation.vue?vue&type=template&id=29e3a734&scoped=true"
import script from "./block-rental-allocation.vue?vue&type=script&lang=js"
export * from "./block-rental-allocation.vue?vue&type=script&lang=js"
import style0 from "./block-rental-allocation.vue?vue&type=style&index=0&id=29e3a734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e3a734",
  null
  
)

export default component.exports